/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Optout_Signal_CaptionInputs */

const en_bot_optout_signal_caption = /** @type {(inputs: Bot_Optout_Signal_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`robots.txt: allow reading, refuse use as AI input`)
};

const id_bot_optout_signal_caption = /** @type {(inputs: Bot_Optout_Signal_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`robots.txt: izinkan pembacaan, larang dipakai sebagai input AI`)
};

/**
* | output |
* | --- |
* | "robots.txt: allow reading, refuse use as AI input" |
*
* @param {Bot_Optout_Signal_CaptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_optout_signal_caption = /** @type {((inputs?: Bot_Optout_Signal_CaptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Optout_Signal_CaptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_optout_signal_caption(inputs)
	return en_bot_optout_signal_caption(inputs)
});